import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { capitalize } from 'lodash'
import { withStyles } from 'beam/dist/styles'
import BeamIcon from 'beam/dist/BeamIcon'
import IconButton from 'beam/dist/IconButton'
import Menu, { MenuItem } from 'beam/dist/Menu'
import { ListItemIcon, ListItemText } from 'beam/dist/List'

const styles = theme => ({
  backItem: {
    outline: 'none',
  },
  backButton: {
    marginLeft: theme.spacing(-1),
    padding: theme.spacing(0.5),
  },
  backText: {
    marginLeft: theme.spacing(1),
  },
  hasSwitch: {
    paddingRight: theme.spacing(7),
  },
})

class SpeechHitsMultiMenu extends Component {
  static propTypes = {
    onCategoryChange: PropTypes.func,
    categories: PropTypes.array.isRequired,
    selectedCategory: PropTypes.string,
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
  }

  static defaultProps = {
    onCategoryChange: () => {},
    selectedCategory: 'ALL',
  }

  state = {
    anchorEl: null,
    open: false,
    categorySubMenuOpen: false,
  }

  handleOpen = anchorEl => {
    this.setState(() => ({
      anchorEl,
      open: true,
      categorySubMenuOpen: false,
    }))
  }
  handleClose = () => {
    this.setState(() => ({
      anchorEl: null,
      open: false,
    }))
  }
  openCategorySubMenu = () => this.setState({ categorySubMenuOpen: true })
  closeCategorySubMenu = () => this.setState({ categorySubMenuOpen: false })

  handleCategoryChange = category => () => {
    this.props.onCategoryChange(category)

    this.handleClose()
  }

  render() {
    const { anchorEl, open } = this.state

    const { categories, selectedCategory, classes, t } = this.props

    const rootMenu = [
      <MenuItem key="root" dense button onClick={this.openCategorySubMenu.bind(this)}>
        <ListItemText primary={`${t('category')}: ${capitalize(selectedCategory)}`} />
        <BeamIcon>ChevronRight</BeamIcon>
      </MenuItem>,
    ]

    const categorySubMenu = [
      <MenuItem dense key={0} button={false} divider className={classes.backItem}>
        <IconButton className={classes.backButton} onClick={this.closeCategorySubMenu.bind(this)}>
          <BeamIcon>ArrowLeft</BeamIcon>
        </IconButton>
        <ListItemText className={classes.backText} primary={t(['chooseCategory', 'Choose a category'])} />
      </MenuItem>,
      ...categories.map((category, i) => (
        <MenuItem dense key={i + 1} onClick={this.handleCategoryChange(category)}>
          {selectedCategory === category && (
            <ListItemIcon>
              <BeamIcon>Check</BeamIcon>
            </ListItemIcon>
          )}
          <ListItemText inset={selectedCategory !== category} primary={capitalize(category)} />
        </MenuItem>
      )),
    ]

    const getMenuItems = () => {
      const { categorySubMenuOpen } = this.state

      if (!categorySubMenuOpen) {
        return rootMenu
      } else if (categorySubMenuOpen) {
        return categorySubMenu
      }
    }

    return (
      <Fragment>
        <IconButton
          color="inherit"
          aria-owns={open ? 'multi-menu' : undefined}
          aria-haspopup="true"
          onClick={event => {
            this.handleOpen(event.currentTarget)
          }}
        >
          <BeamIcon>DotsVertical</BeamIcon>
        </IconButton>
        <Menu
          id="multi-menu"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={open}
          onClose={this.handleClose}
        >
          {getMenuItems()}
        </Menu>
      </Fragment>
    )
  }
}

export default withStyles(styles)(withTranslation()(SpeechHitsMultiMenu))
